import { inject, Injectable } from '@angular/core';
import { ToastMessageOptions, MessageService } from '@openng/optimus-ui/api';

import { DEFAULT_NOTIFICATION_SLOT_KEY, ERROR_NOTIFICATION_SLOT_KEY } from '../constants/app.constants';

export const DEFAULT_NOTIFICATION_DURATION = 3_000;
type MessageSeverity = 'success' | 'warn' | 'info' | 'error';

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  private _messageService = inject(MessageService);

  DEFAULTS: Partial<ToastMessageOptions> = {
    closable: true,
    life: DEFAULT_NOTIFICATION_DURATION,
  };
  lastMessage: string | null = null;

  dispatchSuccess(msg: string, config: ToastMessageOptions = {}) {
    this.dispatchMessage(msg, 'success', {
      summary: 'Úspěch!',
      key: DEFAULT_NOTIFICATION_SLOT_KEY,
      ...config,
    });
  }

  dispatchWarning(msg: string, config: ToastMessageOptions = {}) {
    this.dispatchMessage(msg, 'warn', {
      summary: 'Varování!',
      key: DEFAULT_NOTIFICATION_SLOT_KEY,
      ...config,
    });
  }

  dispatchError(msg: string, config: ToastMessageOptions = {}) {
    this.dispatchMessage(msg, 'error', {
      key: ERROR_NOTIFICATION_SLOT_KEY,
      summary: 'Chyba!',
      ...config,
    });
  }

  dispatchInfo(msg: string, config: ToastMessageOptions = {}) {
    this.dispatchMessage(msg, 'info', {
      summary: 'Info',
      key: DEFAULT_NOTIFICATION_SLOT_KEY,
      ...config,
    });
  }

  clear(slot = DEFAULT_NOTIFICATION_SLOT_KEY) {
    this._messageService.clear(slot);
  }

  private dispatchMessage(msg: string, severity: MessageSeverity, config: ToastMessageOptions) {
    const settings = {
      ...this.DEFAULTS,
      ...config,
    };

    if (msg !== this.lastMessage) {
      this._messageService.add({
        ...settings,
        severity,
        detail: msg,
      });

      this.lastMessage = msg;

      setTimeout(() => {
        this.lastMessage = null;
      }, config.life);
    }
  }
}
